import { $api } from '../axios';

export interface ExternalMatchStats {
  totalMatches: number;
  internalMatches: number;
  supplierMatches: number;
  exactMatches: number;
  alternateMatches: number;
  unknownMatches: number;
}

export interface ExternalMatchUploadRequest {
  name: string;
  sourceName: string;
  sourceType: 'internal' | 'supplier';
  sourceSupplierId?: string;
  flushExisting?: boolean;
}

export interface ExternalMatchUploadResponse {
  jobId: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  totalRows: number;
  processedRows: number;
  matchesCreated: number;
  errors: Array<{
    row: number;
    error: string;
  }>;
}

export interface ExternalMatchUploadStatus {
  jobId: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  totalRows: number;
  processedRows: number;
  matchesCreated: number;
  progress: number;
  errors: Array<{
    row: number;
    error: string;
  }>;
  createdAt: string;
  updatedAt: string;
}

export const externalMatchesService = {
  async getStats(): Promise<ExternalMatchStats> {
    const response = await $api.get('/api/v1/external-matches/stats');
    return response.data.stats;
  },

  async uploadMatches(
    file: File,
    request: ExternalMatchUploadRequest,
  ): Promise<ExternalMatchUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', request.name);
    formData.append('sourceName', request.sourceName);
    formData.append('sourceType', request.sourceType);

    if (request.sourceSupplierId) {
      formData.append('sourceSupplierId', request.sourceSupplierId);
    }

    if (request.flushExisting) {
      formData.append('flushExisting', 'true');
    }

    const response = await $api.post(
      '/api/v1/external-matches/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  },

  async getUploadStatus(jobId: string): Promise<ExternalMatchUploadStatus> {
    const response = await $api.get(
      `/api/v1/external-matches/upload/${jobId}/status`,
    );
    return response.data;
  },
};
